import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import React from 'react';
import { Kit } from '../types/kit/kit';

export interface KitContextProps {
  kits: Map<string, Kit>;
  setKits: (tasks: Map<string, Kit>) => void;
  kitsLoading: boolean;
}

const defaultContext: KitContextProps = {
  kits: new Map(),
  setKits: () => {},
  kitsLoading: false,
};

export const KitContext = React.createContext<KitContextProps>(defaultContext);

interface KitState {
  items: Record<string, any>[];
  loading: boolean;
}

export const kitSlice = createSlice({
  name: 'kit',
  initialState: { items: [], loading: true } as KitState,
  reducers: {
    reset: state => {
      state.items = [];
      state.loading = true;
    },
    set: (state, action: PayloadAction<Kit[]>) => {
      state.items = action.payload.map(p => new Kit(p));
    },
    add: (state, action: PayloadAction<Kit[]>) => {
      const map = new Map([...state.items, ...action.payload.map(p => new Kit(p))].map(pmd => [pmd.id, pmd]));
      state.items = [...map.values()];
    },
    delete: (state, action: PayloadAction<Kit[]>) => {
      const idsToDelete = new Set(action.payload.map(a => a.id));
      state.items = [...state.items.filter(a => !idsToDelete.has(a.id))];
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
  },
});
